import BannerWithImage from 'components/BannerWithImage';
import styles from './ErrorPage.module.less';
import robot from '../../assets/images/robot.svg';
import { I18nt } from 'utils';

export default function ErrorPage() {
	return (
		<section className={styles.section}>
			<BannerWithImage className={styles.bannerImage}>
				<div className={styles.pageWrapper}>
					<div>
						<img src={robot} alt={I18nt('ups_algo_salio_mal')} />
						<h2>{I18nt('ups_algo_salio_mal')}</h2>
						<span>{I18nt('por_favor_vuelve')}</span>
					</div>
				</div>
			</BannerWithImage>
		</section>
	);
}
